import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import instance from "core/constants/request";
import { GENERAL_ENDPOINTS } from "core/constants/endpoints";

const getData = async (): Promise<any> => {
  const res = await instance.get(GENERAL_ENDPOINTS.robots);

  return res.data;
};

type OptionsType = UseQueryOptions<any, unknown, any>;
export const useGetRobots = (config?: OptionsType) => {
  return useQuery({
    queryKey: [GENERAL_ENDPOINTS.robots],
    queryFn: () => getData(),
    ...config,
  });
};
